import { createTheme } from "@mui/material/styles";

export const LandingPageTheme = createTheme({

  
  });
